<p-fieldset styleClass="mt-2">
    <ng-template pTemplate="header">
        <div class="d-flex">
            <fa-icon [icon]='["far","piggy-bank"]'></fa-icon>
            <div class="mx-2">
                Banking Information
            </div>
            <fa-icon [icon]='["far","check-double"]' *ngIf="sectionComplete"></fa-icon>
            <div class="ms-auto">
                <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('banking')"></fa-icon>
            </div>
        </div>
    </ng-template>
    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Bank Routing Number</mat-label>
                <input matInput (change)="inputAction($event)" #bankRoutingNumberField type="text"
                    name="bankRoutingNumberField" [formControl]="bankRoutingNumberControl" [errorStateMatcher]="matcher"
                    [(ngModel)]="merchantBanking.routingNumber" />

                <mat-error *ngIf="bankRoutingNumberControl.errors">
                    <div *ngIf="bankRoutingNumberControl.hasError('required')">Account number is required</div>
                    <div *ngIf="bankRoutingNumberControl.hasError('maxlength') || bankRoutingNumberControl.hasError('minlength')">
                        Account number must be 6 to 17 digits
                    </div>
                    <div *ngIf="bankRoutingNumberControl.hasError('pattern')">Account number is numbers only</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Bank Account Number</mat-label>˙
                <input matInput (change)="inputAction($event)" #bankAccountNumberField type="text"
                    name="bankAccountNumberField" [formControl]="bankAccountNumberControl" 
                    [(ngModel)]="merchantBanking.accountNumber" />

                    <mat-error *ngIf="bankAccountNumberControl.errors">
                        <div *ngIf="bankAccountNumberControl.hasError('required')">An account number is required</div>
                        <div *ngIf="bankAccountNumberControl.hasError('maxlength') || bankAccountNumberControl.hasError('minlength')">
                            Account number must be 6 to 17 digits
                        </div>
                        <div *ngIf="bankAccountNumberControl.hasError('pattern')">Account number is numbers only</div>
                    </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2 flex-fill">
            <mat-form-field class="w-100">
                <mat-label>Bank Name</mat-label>
                <input matInput (change)="inputAction($event)" #bankNameInput type="text" name="bankNameInput"
                    [(ngModel)]="merchantBanking.bankName" [formControl]="bankName"
                    [errorStateMatcher]="matcher" placeholder="Monty Burns Bank & Trust" />
                <mat-error *ngIf="bankName.hasError('required')">Bank name is required</mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">

        </div>
    </div>
</p-fieldset>